// ** Initial State
const initialState = {
  events: [],
  selectedEvent: {},
  selectedCalendars: ["Live", "Multimedia", "Rush", "Rebroadcast"],
  error: null,
  loading: false,
};

const calendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_EVENTS":
      return { ...state, events: action.events };
    case "FETCH_EPISODES":
      return { ...state, events: action.events };
    case "FETCH_DATA_LOADING":
      return { ...state, loading: true, error: null };
    case "EMPTY_ERROR":
    case "ADD_CALENDAR_SUCCESS":
    case "EDIT_CALENDAR_SUCCESS":
      return { ...state, loading: false, error: null };
    case "ADD_CALENDAR_FAIL":
    case "EDIT_CALENDAR_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "REMOVE_EVENT":
      return { ...state };
    case "UPDATE_FILTERS":
      // ** Updates Filters based on action filter
      const filterIndex = state.selectedCalendars.findIndex(
        (i) => i === action.filter
      );
      if (state.selectedCalendars.includes(action.filter)) {
        state.selectedCalendars.splice(filterIndex, 1);
      } else {
        state.selectedCalendars.push(action.filter);
      }
      if (state.selectedCalendars.length === 0) {
        state.events.length = 0;
      }
      return { ...state };
    case "UPDATE_ALL_FILTERS":
      // ** Updates All Filters based on action value
      const value = action.value;
      let selected = [];
      if (value === true) {
        selected = ["Live", "Multimedia", "Rush", "Rebroadcast"];
      } else {
        selected = [];
      }
      return { ...state, selectedCalendars: selected };
    case "SELECT_EVENT":
      return { ...state, selectedEvent: action.event };
    default:
      return state;
  }
};

export default calendarReducer;
